<template>
  <div>
    <div class="bg">
      <div class="bgImg">
        <div class="pageTitle">招生简章</div>
        <img src="@/assets/img/bjing@2x.png" alt="" />
      </div>
    </div>
    <div class="studentBrochure">
      <div class="everyParagraph">
        中央广播电视中等专业学校是一所经原国家教委批准，现由教育部职业教育与成人教育司领导并依托国家开放大学（原中央广播电视大学）设置的中等专业学校，其主要职责是负责全国电大系统中等职业教育的教学和教学管理方面的统筹协调、指导服务和评估监督，并直接面向社会、面向基层、面向农村举办中等职业教育。学校具有颁发国民教育系列成人中等学历教育毕业证书的资格。
      </div>
      <div class="everyParagraph" style="margin-bottom: 20px;">
        中央广播电视中等专业学校依托分校及合作办学单位，运用现代化教学手段和多媒体教学开展中等专业学历教育。
      </div>
      <div class="everyParagraph">一、招生专业</div>
      <div class="everyParagraph">建筑工程施工、会计、机电技术应用、电气技术应用、建筑设备安装、电子商务、市场营销、老年人服务与管理、中药、药剂、学前教育、计算机应用等。</div>
      <div class="everyParagraph">二、招生对象</div>
      <div class="everyParagraph" >应往届初高中毕业生及具有同等学力的社会在职人员。</div>
      <div class="everyParagraph">三、招生时间</div>
      <div class="everyParagraph">全年滚动招生。</div>
      <div class="everyParagraph">四、学习形式</div>
      <div class="everyParagraph">基于互联网+的线上线下相结合的学习形式。</div>
      <div class="everyParagraph">五、学制及入学年龄</div>
      <div class="everyParagraph">初中起点学生可修两年制或三年制专业，两年制学生需年满16周岁，三年制学生需年满15周岁；高中起点学生可修一年制专业，需年满18周岁。</div>
      <div class="everyParagraph">六、学籍有效期</div>
      <div class="everyParagraph">初中起点两年制学籍有效期6年，初中起点三年制学籍有效期8年，高中起点一年制学籍有效期3年。</div>
      <div class="everyParagraph">七、毕业及颁证</div>
      <div class="everyParagraph">学生修完本专业教学计划要求的最低毕业学分并达到最低修业年限的，可获得中央广播电视中等专业学校毕业证书。</div>
      <div class="everyParagraph">学历证书可在中央广播电视中等专业学校的官网上查询并验证，如有需要可以生成学历证书在线验证报告。</div>
    </div>
  </div>
</template>

<script>

export default {
  name: "studentBrochure",
  data() {
    return {
     
    };
  },
  props: [],

  created(){
    
  },
  methods: {},
};
</script>
<style scoped>
/* 背景图片 */
.bgImg {
  position: relative;
  width: 100%;
  height: 272px;
  z-index: 0;
}
.bgImg img {
  width: 100%;
  height: 100%;
}
.bgImg .pageTitle {
  position: absolute;
  top: 82px;
  left: 26px;
  font-size: 25px;
  font-weight: bold;
  color: #FFFFFF;
}
.appName {
  width: 171px;
  background-color: #ffffff4b;
  text-align: center;
  height: 24px;
  line-height: 24px;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  position: absolute;
  top: 104px;
  left: 50%;
  transform: translate(-50%, 0);
}


.studentBrochure {
  overflow-y: scroll;
  position: relative;
  top: -138px;
  height: calc(100vh - 160px);
  line-height: 25px;
  font-size: 14px;
  text-indent: 28px;
  margin: 0 9px 10px;
  border-radius: 8px;
  padding: 21px 15px 18px;
  background-color: #ffffff;
}
.studentBrochure .title {
  font-size: 16px;
  text-align: center;
  font-weight: bold;
  line-height: 60px;
}

</style>